
import ExpandableDescription from "../ExpandableDescription";

interface TutorialContentProps {
  description: string;
  fullDescription?: string;
  steps?: string[];
}

const TutorialContent = ({ description, fullDescription, steps }: TutorialContentProps) => {
  return (
    <>
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Description</h2>
        <ExpandableDescription description={fullDescription || description} />
      </div>
      
      {steps && (
        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-white">Steps</h2>
          <ol className="list-decimal pl-5 space-y-2">
            {steps.map((step, index) => (
              <li key={index} className="text-gray-700 dark:text-gray-100">{step}</li>
            ))}
          </ol>
        </div>
      )}
    </>
  );
};

export default TutorialContent;
